import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  padding-bottom: 16px;
  margin-bottom: 36px;
  border-bottom: 1px solid ${ColorPalette.HEX.BrightGray3};
`;

export const Left = styled.div`
  flex: 1;
`;

export const Title = styled.h1`
  font-weight: bold;
  font-size: 2.2em;
  line-height: 1em;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const Subtitle = styled.h2`
  color: ${ColorPalette.HEX.DimGray};
  font-size: 1em;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
`;
